import createAction from 'services/createAction';

const GET_CAR_MODELS = 'carModels/GET';
const GET_CAR_MODELS_SUCCESS = 'carModels/GET_SUCCESS';
const GET_CAR_MODELS_FAILED = 'carModels/GET_FAILED';

const initialState = {
  data: {},
  error: {
    message: '',
  },
  loading: {
    carModels: false,
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case GET_CAR_MODELS_SUCCESS:
    return {
      ...state,
      data: payload,
      loading: { ...state.loading, carModels: false },
    };
  case GET_CAR_MODELS_FAILED:
    return {
      ...state,
      error: { message: payload },
      loading: { ...state.loading, carModels: false },
    };
  case GET_CAR_MODELS:
    return {
      ...state,
      error: { message: '' },
      loading: { ...state.loading, carModels: true },
    };
  default:
    return state;
  }
};

const getCarModelsSuccess = createAction(GET_CAR_MODELS_SUCCESS);
const getCarModelsFailed = createAction(GET_CAR_MODELS_FAILED);

export const getCarModels = () => (dispatch, getState, api) => {
  dispatch({ type: GET_CAR_MODELS });

  api.get({ path: 'management/model' })
    .then((res) => {
      dispatch(getCarModelsSuccess(res));
    })
    .catch((err) => {
      dispatch(getCarModelsFailed({ message: err.data }));
    });
};
